/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Retailer } from './Retailer';

export type OfferItemIdentity = {
    id: string;
    type: OfferItemIdentity.type;
    value: string;
    partialMatchThreshold: number;
    fullMatchThreshold: number;
    merchants: Array<Retailer>;
    isActive: boolean;
};

export namespace OfferItemIdentity {

    export enum type {
        SKU = 'SKU',
        NAME = 'NAME',
        AI = 'AI',
    }


}

